export default __webpack_public_path__ + "static/media/grafema_martini-contest_01.7830d131.jpg";